import type { MaybeRefOrGetter, Ref } from 'vue'

interface UseProductListPositionTrackingOptions {
  /** Skip attaching the listener (e.g. the PDP-detail render of a card, not a list tile). */
  enabled: MaybeRefOrGetter<boolean>
  /** Template ref for the card's root element (Vuetify components expose `$el`). */
  cardRef: Ref<{ $el?: HTMLElement } | null>
  /** Product identifier to remember the position for. */
  getIdExternal: () => string
  /** 1-based position of this card in the rendered list. */
  getPosition: () => number
}

// Capture-phase: PDP nav is a plain <a>; feeds useViewItemPosition for GA4 index.
export function useProductListPositionTracking(options: UseProductListPositionTrackingOptions): void {
  const { rememberPosition } = useViewItemPosition()

  // Vuetify components expose the DOM node on `$el`; resolve after mount.
  const target = computed(() => {
    if (!toValue(options.enabled)) return null
    return options.cardRef.value?.$el ?? null
  })

  useEventListener(
    target,
    'click',
    (event: MouseEvent) => {
      const anchor = (event.target as HTMLElement)?.closest?.('a')
      if (!anchor || !anchor.href?.includes('/product/')) return
      rememberPosition(options.getIdExternal(), options.getPosition())
    },
    { capture: true },
  )
}
